import { render } from "./Program04.vue?vue&type=template&id=00c1ebe8"
import script from "./Program04.vue?vue&type=script&lang=js"
export * from "./Program04.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__